import React from 'react';
import { LocaleService } from '@sm360/widget-commons-core-services';

import 'login/components/Library/Separator/Separator.scss';

const SeparatorView = () => (
    <div className="separator">
        <span>{LocaleService.t('LOGIN.OR')}</span>
    </div>
);

SeparatorView.displayName = 'SeparatorView';

export default SeparatorView;
